import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFileXClose = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>FileXClose</title>
    <path
      d="M25.857 12.75v14.525a2.429 2.429 0 0 1-2.428 2.428H8.57a2.429 2.429 0 0 1-2.428-2.428V6.703A2.429 2.429 0 0 1 8.57 4.274h8.476c.621 0 1.219.239 1.67.666l6.382 6.046c.484.459.758 1.096.758 1.763Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="m13.17 23.246 5.658-5.657M13.17 17.587l5.657 5.657"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M25.713 12.417h-4.572a3.429 3.429 0 0 1-3.428-3.429V4.417"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoFileXClose;
